import { breakpoints } from '@bnnvara/breakpoints';
import { IconButton } from '@bnnvara/buttons/src/components/IconButton/styled';
import styled from 'styled-components';

export const SearchButton = styled(IconButton)`
  width: 24px;
  height: 24px;

  ${breakpoints.md} {
    width: 32px;
    height: 32px;
  }
`;
